import {Link} from "react-router-dom";
import LOGO from "../assets/media/svg/logo.svg";
import {NavLink} from "react-router-dom";

const Footer = (props: any) => {
    return (
        <footer className="pt-md-8 pt-6">
            <div className="bg-black">
                <hr className="m-0 p-0" />
                <div className="pb-5 pt-10">
                    <div className="container">
                        <div className="row gy-3 justify-content-between">
                            <div className="col-md-auto">
                                <NavLink to="/">
                                    <img src={LOGO} alt="logo" />
                                </NavLink>
                            </div>
                            <div className="col-md-auto">
                                <p className="mb-2 mb-lg-0 text-white">
                                    @ {new Date().getFullYear()} <span>|</span>
                                    {props.pageType == "privacy-policy" && (
                                        <>
                                            <Link to="/privacy-policy" className="text-white text-decoration-none ms-1">
                                                Privacy Policy
                                            </Link>{" "}
                                        </>
                                    )}
                                    {props.pageType == "terms-and-conditions" && (
                                        <Link
                                            to="/terms-and-conditions"
                                            className="text-white text-decoration-none ms-1"
                                        >
                                            Terms & Conditions
                                        </Link>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
